export function hasPermissionWA(state, networkId, permission) {
  let canAccess = true;
  if (
    state.waitingAreaReducer &&
    state.waitingAreaReducer.waitingAreas &&
    state.waitingAreaReducer.waitingAreas.length > 0
  ) {
    var wa = state.waitingAreaReducer.waitingAreas.find((x) => x.id == networkId);

    if (wa) {
      if (permission && permission != '' && wa.permissions != undefined && !wa.permissions.includes(permission)) {
        canAccess = false;
      }
    } else {
      canAccess = false;
    }
  } else if (
    state.waitingAreaReducer &&
    state.waitingAreaReducer.waitingAreas &&
    state.waitingAreaReducer.waitingAreas.length === 0
  ) {
    canAccess = false;
  }
  return canAccess;
}

export function hasPermissionOrg(state, networkId, permission) {
  let canAccess = true;
  if (
    state.organisationsReducer &&
    state.organisationsReducer.organisations &&
    state.organisationsReducer.organisations.length > 0
  ) {
    var org = state.organisationsReducer.organisations.find((x) => x.networkId == networkId);

    if (org) {
      if (permission && permission != '' && org.permissions != undefined && !org.permissions.includes(permission)) {
        canAccess = false;
      }
    } else {
      canAccess = false;
    }
  } else if (
    state.organisationsReducer &&
    state.organisationsReducer.organisations &&
    state.organisationsReducer.organisations.length === 0
  ) {
    canAccess = false;
  }
  return canAccess;
}

export function hasPermissionMR(state, networkId, permission) {
  if (
    state.meetingRoomReducer &&
    state.meetingRoomReducer.meetingRooms &&
    state.meetingRoomReducer.meetingRooms.length > 0
  ) {
    var mr = state.meetingRoomReducer.meetingRooms.find((x) => x.id == networkId);

    if (mr) {
      if (permission && permission != '' && mr.permissions != undefined && !mr.permissions.includes(permission)) {
        return false;
      }
    } else {
      return false;
    }
  } else if (
    state.meetingRoomReducer &&
    state.meetingRoomReducer.meetingRooms &&
    state.meetingRoomReducer.meetingRooms.length === 0
  ) {
    return false;
  }
  return true;
}
